/** Keep in sync with backend `lib/chat/thinking_phrases.py`. */
const THINKING_PHRASES = [
  'Thinking...',
  'Working on that...',
  'One moment...',
  'Gathering context...',
  'Processing your request...',
  'Almost there...',
  'Looking into this...',
  'Crunching the numbers...',
  'Hang tight...',
  'Figuring this out...',
  'Magic happening...',
  'Aha moment loading...',
  'Spinning up brilliance...',
  'Fetching brain cells...',
  'Warming up neurons...',
  'Putting on my thinking cap...',
  'Dots are connecting...',
  'Loading cleverness...',
  'Tea break (just kidding)...',
  '🧠 in progress...',
  'Just a sec...',
  'Wizardry happening...',
];

export function pickThinkingPhrase() {
  return THINKING_PHRASES[Math.floor(Math.random() * THINKING_PHRASES.length)];
}
